function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Button, IconButton, TableList, Tooltip, Typography, WithInfoIcon } from 'seagull';
import { TrashFill18 } from 'seagull/icons';
import { makeTestId, displayLineItemRate, getClientStatusTooltip, getVendorStatusTooltip } from "./ScheduledInvoice.utils";
import styles from "./ScheduledInvoice.module.scss";
import { LineItemType } from "../../../../models/invoice-draft";
import { emptyCell } from "../../../../constants";
import { Intent } from "../../../../infra/access-control";
import { utils } from "../../../../utils";
import { LineItemPendingApprovalReason } from "../../../../types/api.model";
export function CustomerLineItem(props) {
  const {
    onApprove
  } = props;
  const {
    pendingApprovalReason
  } = props.charge;
  const testid = makeTestId(props.charge);
  const action = pendingApprovalReason === LineItemPendingApprovalReason.AdHocCharge ? /*#__PURE__*/React.createElement(Button, {
    skin: "primaryOutline",
    intent: Intent.ApproveCharge,
    size: "small",
    "data-testid": "".concat(testid, "-approve"),
    onClick: onApprove
  }, "Approve") : null;
  return /*#__PURE__*/React.createElement(LineItem, _extends({}, props, {
    testid: testid,
    action: action,
    getStatusTooltip: getClientStatusTooltip
  }));
}
export function VendorLineItem(props) {
  const {
    onRemove
  } = props;
  const testid = makeTestId(props.charge);
  const action = /*#__PURE__*/React.createElement(VendorLineItemAction, _extends({
    testid: testid
  }, makeRemoveButtonProps(props.charge, onRemove)));
  return /*#__PURE__*/React.createElement(LineItem, _extends({}, props, {
    testid: testid,
    action: action,
    getStatusTooltip: getVendorStatusTooltip
  }));
}
const makeRemoveButtonProps = (charge, onRemove) => {
  const {
    type
  } = charge;
  let removeButton;
  switch (type) {
    case LineItemType.Credit:
      removeButton = {
        disabled: true,
        tooltip: 'Credit can be disabled from the Billing Control',
        dataIntent: 'credit',
        intent: undefined
      };
      break;
    case LineItemType.Automatic:
      removeButton = {
        disabled: true,
        tooltip: 'Automatic services can be paused from the Billing Control',
        dataIntent: 'ongoing-service',
        intent: undefined
      };
      break;
    case LineItemType.Manual:
    case LineItemType.AdHocCharge:
      removeButton = {
        disabled: false,
        tooltip: 'Remove from invoice',
        dataIntent: 'active',
        intent: Intent.RemoveCharge
      };
      break;
  }
  return _objectSpread(_objectSpread({}, removeButton), {}, {
    onClick: onRemove
  });
};
function LineItem(rowProps) {
  const {
    charge,
    testid,
    addedLineItemId,
    action,
    getStatusTooltip
  } = rowProps;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableList.Row, {
    "data-testid": testid,
    addPulse: charge.id === addedLineItemId,
    size: "small",
    disableMarginBottom: !!charge.note,
    items: [{
      value: /*#__PURE__*/React.createElement(Typography, {
        variant: "paragraph2",
        ellipsis: true,
        "data-testid": "".concat(testid, "-name")
      }, charge.name)
    }, {
      value: charge.quantity ? /*#__PURE__*/React.createElement(Typography, {
        variant: "paragraph2",
        "data-testid": "".concat(testid, "-quantity")
      }, utils.formatNumberWithCommas(charge.quantity)) : null
    }, {
      value: /*#__PURE__*/React.createElement(Typography, {
        variant: "paragraph2",
        ellipsis: true,
        "data-testid": "".concat(testid, "-rate")
      }, displayLineItemRate(charge.rate))
    }, {
      value: /*#__PURE__*/React.createElement(Typography, {
        variant: "paragraph2",
        "data-testid": "".concat(testid, "-discount")
      }, charge.discount ? charge.discount.format() : '')
    }, {
      value: /*#__PURE__*/React.createElement(Typography, {
        variant: "paragraph2",
        "data-testid": "".concat(testid, "-total")
      }, utils.formatDollarAmount(charge.totalAmount))
    }, {
      value: charge.pendingApprovalReason && /*#__PURE__*/React.createElement(WithInfoIcon, {
        info: getStatusTooltip(charge.pendingApprovalReason)
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "paragraph2",
        "data-testid": "".concat(testid, "-status"),
        "data-intent": charge.pendingApprovalReason
      }, "Pending approval"))
    }, {
      value: action
    }]
  }), charge.note && /*#__PURE__*/React.createElement(TableList.Row, {
    "data-testid": "".concat(testid, "-note"),
    addPulse: addedLineItemId === charge.id,
    size: "fluid",
    items: [{
      value: /*#__PURE__*/React.createElement(Typography, {
        variant: "paragraph2",
        skin: "secondary",
        breakWords: true
      }, charge.note)
    }, emptyCell, emptyCell, emptyCell, emptyCell, emptyCell, emptyCell]
  }));
}
function VendorLineItemAction(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.vendorAction
  }, /*#__PURE__*/React.createElement(IconButton, {
    noPadding: true,
    size: "small",
    skin: "primaryTransparent",
    disabled: props.disabled,
    "data-testid": "".concat(props.testid, "-remove"),
    "data-intent": props.dataIntent,
    intent: props.intent,
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement(Tooltip, {
    placement: "top",
    title: props.tooltip
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(TrashFill18, null)))));
}